import { TimeStamp } from "@/models/timestamp";

export const MATRIX_TABLE_DATA_WIDTH = 80;

export type DragColumn = {
  id: number;
  index: number;
  offsetLeft: number;
  offsetTop: number;
  offsetWidth: number;
};

export type MatrixSearchParams = {
  categoryId: number;
  primaryChargeId: number;
  areaIds?: number[];
  deviceIds?: number[];
  facilityManagementIds?: number[];
  constructionManagementIds?: number[];
  otherIds?: number[];
  systemIds?: number[];
  companyIds?: number[];
  userIds?: number[];
  groupIds?: number[];
  processMiddleClassIds?: number[];
  itemText?: string;
  processText?: string;
  regulation?: string;
  filters?: number[];
};

// 保存する検索条件は、APIのパラメータと同じキーにする
export type MatrixFilterConfig = {
  category_id: number;
  primary_charge_id: number;
  area_id?: number[];
  device_id?: number[];
  facility_management_id?: number[];
  construction_management_id?: number[];
  other_id?: number[];
  system_id?: number[];
  company_id?: number[];
  user_id?: number[];
  group_id?: number[];
  process_middle_class_ids?: number[];
  item_text?: string;
  process_text?: string;
  regulation?: string;
  filter?: number[];
};

export type MatrixItem = {
  item_id: number;
  item_name: string;
  sort: number;
};

export type Process = {
  process_id: number;
  category_id: number;
  process_major_class_id: number;
  process_major_class_name?: string;
  process_middle_class_id: number;
  process_middle_class_name?: string;
  coordinate_flg: boolean;
  company_id: number;
  company_name?: string;
  process_name: string;
  output_flg: boolean;
  schedule_roles: number[];
  schedule_mapping_flg?: boolean;
  weight: number;
  sort: number;
  roles: number[];
  lock_flg: boolean; // ロックの設定をしている作業（完了する条件となる作業を設定している）
  key_flg: boolean; // ロックの条件となっている作業（他の作業の完了条件となっている）
  key_processes: number[]; // 完了条件となる作業ID
  timestamp: TimeStamp;
};

export type MatrixTask = {
  process_id: number;
  task_id: number;
  valid_flg: true;
  schedule_type: number;
  status: number;
  display_status: string;
  ahead_days: number;
  schedule_date: string;
  progress: number;
  schedule_start_date: string;
  schedule_end_date: string;
  result_start_date: string;
  result_end_date: null;
  checkpoints: number[];
  document_no: string;
  user_id: number;
  group_id: null;
  user_name: string;
  display_user_name: string;
  file_status: false;
  warning_flg: false;
  warning_messages: object[];
  background_color: number;
  comments: object[];
  completion_user_id: number;
  completion_user_name: string;
  timestamp: TimeStamp;
  roles: number[];
};

export type MatrixRow = {
  item_id: number;
  no: string;
  item_name: string;
  category_id: number;
  area_id: number;
  area_name: string;
  device_id: number;
  device_name: string;
  primary_charge_id: string;
  primary_charge_name: string;
  facility_management_id: number;
  facility_management_name: string;
  construction_management_id: number;
  construction_managemenet_name: string;
  other_id: number;
  other_name: string;
  user_id: number;
  group_id: string;
  user_name: string;
  regulation: string;
  item_complete: boolean;
  sort: number;
  note: string;
  remark: string;
  attention_flg: boolean;
  delivery_flg: boolean;
  document_no: string;
  totaltest: boolean;
  file_status: boolean;
  systems: object[];
  tasks: MatrixTask[];
  timestamp: TimeStamp;
  roles: number[];
};

export type ProcessSegmentLabel = {
  segment_label_id: number;
  category_id: number;
  primary_charge_id: number;
  sort: number;
  segment_label_name: string;
};

export const MatrixSearchKey = {
  Category: "category_id",
  PrimaryCharge: "primary_charge_id",
  Area: "area_id",
  Device: "device_id",
  FacilityManagement: "facility_management_id",
  ConstructionManagement: "construction_management_id",
  Other: "other_id",
  Company: "company_id",
  ProcessMiddleClass: "process_middle_class_id",
  Regulation: "regulation",
  System: "system_id",
  User: "user_id", // 担当者: userとgroup
  ItemText: "item_text",
  ProcessText: "process_text",
  FilterComing: "filter_coming", // 予定工事
  FilterExpired: "filter_expired", // 作業期限超
  FilterAssigned: "filter_assigned", // 担当作業
  FilterNotCompleted: "filter_not_completed", // 未完了
} as const;

export type MatrixSearchKeyType = (typeof MatrixSearchKey)[keyof typeof MatrixSearchKey];

export const MatrixColumnKey = {
  No: "no",
  DeliveryFlg: "delivery_flg",
  ItemComplete: "item_complete",
  Totaltest: "totaltest",
  Area: "area",
  Device: "device",
  PrimaryCharge: "primary_charge",
  DocumentNo: "document_no",
  Item: "item",
  SpecialWork: "special_work", // 千葉専用
  Protection: "protective_equipment", // 千葉専用
  Regulation: "regulation",
  Systems: "systems",
  Note: "note",
  User: "user",
} as const;

export type MatrixColumnKeyType = (typeof MatrixColumnKey)[keyof typeof MatrixColumnKey];
